// extracted by mini-css-extract-plugin
export default {"bold":"FedHelpUi_bold__yTWvP"};